import {
  SingleItemResponse,
  SingleItemData,
  ItemDescriptionParams,
} from '../../items/slice/types';
import { itemMedia } from '../../../../utils/itemMedia';
import { groupAttributes } from 'utils/groupAttributes';

export const constructItemDescription: (
  vals: ItemDescriptionParams,
) => string = values => {
  const {
    thickness,
    series,
    shape,
    outerDiameter,
    innerDiameter,
    numberOfBoltHoles,
    diameterOfBoltHoles,
    outsideLength,
    outsideWidth,
    length,
    width,
    shapeLabel,
    boltholeAbbreviation,
    pitchCircle,
    insideLength,
    insideWidth,
    type,
  } = values;

  const boltHoles =
    numberOfBoltHoles !== '0'
      ? `${boltholeAbbreviation}${pitchCircle} ${numberOfBoltHoles}x${diameterOfBoltHoles}mm`
      : '';
  if (shape === 'ring') {
    //shape; FF when with bolt holes; material; OD; ID; thickness; bcd; quantity bolt holes; dia bolt hole
    return `${shapeLabel} ${series} ${type} ${outerDiameter}x${innerDiameter}x${thickness} ${boltHoles}`;
  }
  if (shape === 'frame') {
    return `${shapeLabel} ${series} ${type} ${outsideLength}x${outsideWidth}x${insideLength}x${insideWidth}x${thickness}`;
  }
  if (shape === 'disc') {
    // shape; FF when with bolt holes; material; OD; thickness; bcd; quantity bolt holes; dia bolt hole
    return `${shapeLabel} ${series} ${type} ${outerDiameter}x${thickness} ${boltHoles}`;
  }
  if (shape === 'strip') {
    return `${shapeLabel} ${series} ${type} ${length}x${width}x${thickness}`;
  }
  return '';
};

export const transformDTO: (
  dto: SingleItemResponse,
) => SingleItemData = dto => {
  const typeAttribute = dto.attributes.find(
    attribute => attribute.featureName === 'TYPE_LOCAL_GAS',
  );
  const compoundAttribute = dto.attributes.find(
    attribute => attribute.attributeIdentifier === 'EGTF_6043__STRING',
  );

  return {
    productId: dto.productId,
    series: dto.series,
    type: typeAttribute?.value || '',
    partNumber: dto.partNumber,
    erpPartNumber: dto.erpPartNumber,
    brand: dto.brand,
    description: dto.description,
    image: itemMedia(dto.medias, ['product image', 'item image'])[0],
    dataSheet: itemMedia(dto.medias, ['product data sheet'])[0],
    logos: itemMedia(dto.medias, 'product icon'),
    length: dto.length,
    width: dto.width,
    thickness: dto.thickness,
    configuration: dto.configuration,
    englishDescription: dto.englishDescription,
    attributes: groupAttributes(dto.attributes),
    ...(compoundAttribute ? { gskCompound: compoundAttribute.value } : {}),
  };
};
